export default __webpack_public_path__ + "static/media/loop-logo-modal.5f3cf2dd.png";